import * as React from 'react';

const QuickRepliesBadge72 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 72 72", width: 72, height: 72, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M72 36c0 19.881-16.117 36-36 36C16.119 72 0 55.881 0 36 0 16.117 16.119 0 36 0c19.883 0 36 16.117 36 36"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M17.352 23.1a6.2 6.2 0 0 0-.524 2.468v10.215c0 .938.755 1.6 1.686 1.477s1.685-.984 1.685-1.923v-9.876L33.52 36.51c2.183 1.81 5.615 1.357 7.798-1.031l14.191-15.524q.053.235.054.493v20.431c0 1.27-1.02 2.434-2.279 2.601l-42.599 5.658c-.93.124-1.685.985-1.684 1.924 0 .939.756 1.6 1.686 1.476l42.6-5.658c3.119-.414 5.647-3.3 5.647-6.447v-20.43c0-3.149-2.53-5.366-5.651-4.954L22.48 19.121c-2.207.292-4.12 1.822-5.05 3.806l-.116.14.04.032Zm4.993-.557q.067-.013.134-.022l30.016-3.968-13.503 14.772c-.881.964-2.267 1.147-3.147.416z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M12.823 42.734c0-.939.755-1.793 1.687-1.907l7.46-.916c.931-.114 1.687.554 1.687 1.493s-.756 1.792-1.688 1.907l-7.46.916c-.931.114-1.686-.554-1.686-1.493m11.5 11.458c-.932.114-1.687.968-1.687 1.907s.755 1.607 1.687 1.493L38.922 55.8c.932-.115 1.687-.969 1.687-1.908s-.755-1.607-1.687-1.492z"
  }
));
QuickRepliesBadge72.Size = 72;
QuickRepliesBadge72.Title = "QuickRepliesBadge";

export { QuickRepliesBadge72 as default };
